import { single_mosfet } from './single_mosfet';
import { UNITS_SIGN } from '../../constants/definitionConstants';

export class ntmfws1d5n08xt1g extends single_mosfet {
	constructor(opn) {
		super(opn, 'ntmfws1d5n08x');
		this.PACKAGE_IMAGE = require(`../../images/DFNW5_CASE_507BA.png`);
		this.modelLink = `https://www.${this.domain}/download/models/zip/t10_80v_std_pspice.zip`;
		this.netlistPath = `resources/${this.wpn}/${this.opn}/netlists/${this.opn}_3P_DC.txt`;
	}

	gainDefinition() {
		const customizations = {
			simulations: [
				{
					inputParameters: [
						{
							/**
							 * base heading (heading is created from heading + unit)
							 */
							heading: 'V<sub>GS<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							/**
							 * if unit is not base unit but for example it is in kilo ohm it is needed
							 * to add extension for simulator which tells that it is kilo that’s mean ‘k’
							 */
							netlistUnit: '',
							/**
							 * exact name of parameter from netlist to be replaced
							 */
							mappingName: 'VgsMin',
							minBoundary: 0.1,
							maxBoundary: 15,
							defaultValue: 4.5
						},
						{
							heading: 'V<sub>GS<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgsMax',
							minBoundary: 0.2,
							maxBoundary: 20,
							defaultValue: 8
						},
						{
							heading: 'V<sub>GS<sub>(increment)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgsStep',
							minBoundary: 0.25,
							maxBoundary: 5,
							defaultValue: 0.25
						},
						{
							heading: 'V<sub>D<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VdMin',
							minBoundary: 0.1,
							maxBoundary: 10,
							defaultValue: 0.25
						},
						{
							heading: 'V<sub>D<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VdMax',
							minBoundary: 1,
							maxBoundary: 20,
							defaultValue: 5
						},
						{
							heading: 'V<sub>D<sub>(increment)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VdStep',
							minBoundary: 0.1,
							maxBoundary: 5,
							defaultValue: 0.5
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -40,
							maxBoundary: 150,
							defaultValue: 25,
							displayInput: true
						}
					]
				}
			]
		};
		return super.gainDefinition(customizations);
	}
}
